import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class BairroService {
  private data = null;
	private url = environment.serviceApi;
  constructor(public http: Http) { }

  getBairros(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/bairros' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
  }
  
  getBairro(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/bairros/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getBairroByMunicipio(municipioId) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/bairros/municipio/' + municipioId)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
